import objectAssign from 'object-assign'


import Vue from 'vue';


import rem from './rem';
Vue.use(rem);

import 'babel-polyfill'
import Es6Promise from 'es6-promise'
require('es6-promise').polyfill()
Es6Promise.polyfill()

import Vuex from 'vuex'
import vuexI18n from 'vuex-i18n'
import vuxLocales from './locales/all.yml'
import componentsLocales from './locales/components.yml'
Vue.use(Vuex);
let store = new Vuex.Store({
modules: {
i18n: vuexI18n.store
}
})
Vue.use(vuexI18n.plugin, store)

const finalLocales = {
'en': objectAssign(vuxLocales['en'], componentsLocales['en']),
'zh-CN': objectAssign(vuxLocales['zh-CN'], componentsLocales['zh-CN'])
}
for (let i in finalLocales) {
Vue.i18n.add(i, finalLocales[i])
}

import LocalePlugin from 'vux/src/plugins/locale/index.js'

Vue.use(LocalePlugin)
const nowLocale = Vue.locale.get()
if (/zh/.test(nowLocale)) {
Vue.i18n.set('zh-CN')
} else {
Vue.i18n.set('en')
}

import ToastPlugin from 'vux/src/plugins/toast/index.js'
import AlertPlugin from 'vux/src/plugins/alert/index.js'
import ConfirmPlugin from 'vux/src/plugins/confirm/index.js'
import LoadingPlugin from 'vux/src/plugins/loading/index.js'


Vue.use(ToastPlugin)
Vue.use(AlertPlugin)
Vue.use(ConfirmPlugin)
Vue.use(LoadingPlugin)

import axios from 'axios';

import global from './components/common/global.vue'
Vue.prototype.GLOBAL = global;
axios.defaults.withCredentials=true;
axios.defaults.timeout=360000;
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=utf-8';

axios.interceptors.request.use(function (config) {
return config;
}, function (error) {
return Promise.reject(error);
});
axios.interceptors.response.use(function (response) {
return response;
}, function (error) {
return Promise.reject(error);
});

Vue.prototype.$ajax=axios;
Vue.config.productionTip = false;

import loverI18n from '@/utils/i18nChange.js'
Vue.prototype.$loverI18n = loverI18n;

import loverImage from '@/utils/image.js'
Vue.prototype.$loverImage = loverImage;

import loverDate from '@/utils/date_format.js'
Vue.prototype.$loverDate = loverDate;

import defaultImg from '@/utils/defaultImg.js';
Vue.use(defaultImg);

import router from './router';
import App from './App';
import "./assets/css/style.css"


import { sync } from 'vuex-router-sync'

store.registerModule('vux', {
state: {
isLoading: false,
direction: ''
},
mutations: {
updateLoadingStatus (state, payload) {
state.isLoading = payload.isLoading
},
updateDirection (state, payload) {
state.direction = payload.direction
}
},
actions: {
}
})

Vue.use(store)
sync(store, router)

var isLoad = true;
var isSlide = false;

router.beforeEach(function (to, from, next) {

var time = isLoad?0:0;



isLoad = false;

store.commit('updateLoadingStatus', {isLoading: true})

if(isSlide==true){
if (to.meta.index > from.meta.index) {
store.commit('updateDirection', {direction: 'slide-left'})
} else {
store.commit('updateDirection', { direction: 'slide-right' })
}
}

isSlide = true;

if (/\/http/.test(to.path)) {
let url = to.path.split('http')[1]
window.location.href = `http${url}`
} else {
next()
}


})

router.afterEach(function (to) {
store.commit('updateLoadingStatus', {isLoading: false})
})

new Vue({
router,
store,
render: h => h(App)
}).$mount('#app')











// WEBPACK FOOTER //
// ./src/main.js